import TopNav from "./Home/TopNav";
import Footer from "./Home/Footer";
import OrganizationSchema from "./OrganizationSchema";

const Layout = ({ children }) => {
  return (
    <>
      <OrganizationSchema />
      <TopNav />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
